import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { AllStatuses } from '../types';
const RegisteredStatusesCustomComponents = AllStatuses == null ? void 0 : AllStatuses.reduce((acc, status) => {
  acc[status] = undefined;
  return acc;
}, {});
export const StatusesCustomComponentsExtension = ModuleExtensions.customComponentsExtension(RegisteredStatusesCustomComponents, 'statusesCustomComponents');
//# sourceMappingURL=StatusesCustomComponents.js.map